import React from "react";
import classnames from "classnames";

// Style
import Styles from "./AdvisorsInvesters.module.scss";

// Icons
import LinkedinIcon from "@vahak/core/dist/icons/linkedinIconWhite.svg";
import ExternalLink from "@vahak/core/dist/icons/external-link.svg";

// Component
import A from "@vahak/core/dist/components/app-anchor/A";
import OnScrollFadeIn from "@vahak/core/dist/components/onscrollfadein/OnScrollFadeIn";
import AppImg from "components/utils/AppImg";

const advisorsInvesters = [
    {
        id: 1,
        profileImgLarge: `leo_capital.png`,
        profileImgSmall: `leo_capital.png`,
        name: "Leo Capital",
        jobTitle: "Tech VC",
        linkedinLink: "https://www.linkedin.com/company/leodotcapital/"
    },
    {
        id: 2,
        profileImgLarge: `Amit.png`,
        profileImgSmall: `Amit.png`,
        name: "Amit Gupta",
        jobTitle: "Founder, Yulu Bikes",
        linkedinLink: "https://www.linkedin.com/in/amitgupta007/"
    },
    {
        id: 3,
        profileImgLarge: `Abishek.png`,
        profileImgSmall: `Abishek.png`,
        name: "Abhishek Goyal",
        jobTitle: "Founder, Tracxn",
        linkedinLink: "https://www.linkedin.com/in/abhishekgoyal/"
    },
    {
        id: 4,
        profileImgLarge: `Ramakant.png`,
        profileImgSmall: `Ramakant.png`,
        name: "Ramakant Sharma",
        jobTitle: "Founder, LivSpace",
        linkedinLink: "https://www.linkedin.com/in/sharmaramakant/"
    },
    {
        id: 5,
        profileImgLarge: `Harsh.png`,
        profileImgSmall: `Harsh.png`,
        name: "Harsh Pokharna",
        jobTitle: "Founder, OkCredit",
        linkedinLink: "https://www.linkedin.com/in/harsh-pokharna/"
    },
    {
        id: 6,
        profileImgLarge: `unnamed_02-Desktop.png`,
        profileImgSmall: `unnamed_02-Desktop.png`,
        name: "Archana Priyadarshini",
        jobTitle: "Partner, PointOne Capital",
        linkedinLink: "https://www.linkedin.com/in/archana-priyadarshini-5477071/"
    },
    {
        id: 7,
        profileImgLarge: `Logo-RTP-Global.png`,
        name: "RTP Global",
        jobTitle: "VC",
        websiteLink: "https://rtp.vc/"
    },
    {
        id: 8,
        profileImgLarge: `uxor-capital-v1.png`,
        name: "Luxor Capital",
        jobTitle: "VC",
        websiteLink: "https://luxorcap.com/"
    },
    {
        id: 9,
        profileImgLarge: `titan-capital-v1.png`,
        name: "Titan Capital",
        jobTitle: "VC",
        websiteLink: "https://www.titancapital.vc/"
    },
    {
        id: 10,
        profileImgLarge: `kunal-shah.png`,
        name: "Kunal Shah",
        jobTitle: "Founder of Cred, Freecharge",
        linkedinLink: "https://www.linkedin.com/in/kunalshah1"
    },
    {
        id: 11,
        profileImgLarge: `jitendra-gupta.png`,
        name: "Jitendra Gupta",
        jobTitle: "Founder of Jupiter",
        linkedinLink: "https://www.linkedin.com/in/guptajiten"
    },
    {
        id: 12,
        profileImgLarge: `harsimarbir-singh.png`,
        name: "Harsimarbir Singh",
        jobTitle: "Founder of Prystine Care",
        linkedinLink: "https://www.linkedin.com/in/harsimarbirsingh"
    },
    {
        id: 13,
        profileImgLarge: `ravish-naresh.png`,
        name: "Ravish Naresh",
        jobTitle: "Founder of Khatabook",
        linkedinLink: "https://www.linkedin.com/in/ravish-naresh-72543359"
    },
    {
        id: 14,
        profileImgLarge: `amrish-rau.png`,
        name: "Amrish Rau",
        jobTitle: "CEO of PineLabs",
        linkedinLink: "https://www.linkedin.com/in/amrish-rau-4158339"
    },
    {
        id: 15,
        profileImgLarge: `vidit-aatrey.png`,
        name: "Vidit Aatrey",
        jobTitle: "Founder of Meesho",
        linkedinLink: "https://www.linkedin.com/in/vidit-aatrey-a3639120"
    },
    {
        id: 16,
        profileImgLarge: `sanjeev-barnwal.png`,
        name: "Sanjeev Barnwal",
        jobTitle: "Founder of Meesho",
        linkedinLink: "https://www.linkedin.com/in/sanjeev-barnwal-4099341b"
    },
    {
        id: 17,
        profileImgLarge: `nexus-venture_partners-v1.png`,
        name: "Nexus Venture Partners",
        jobTitle: "VC",
        websiteLink: "https://nexusvp.com/"
    },
    {
        id: 18,
        profileImgLarge: `foundamental-v1.png`,
        name: "Foundamental",
        jobTitle: "VC",
        websiteLink: "https://foundamental.com/"
    },
    {
        id: 19,
        profileImgLarge: `iseed-ventures-v1.png`,
        name: "iseed",
        jobTitle: "VC",
        websiteLink: "https://www.iseed.vc/home"
    },
    {
        id: 20,
        profileImgLarge: `farid-ahsan.png`,
        name: "Farid Ahsan",
        jobTitle: "Founder of Sharechat",
        linkedinLink: "https://www.linkedin.com/in/faridahsan"
    },
    {
        id: 21,
        profileImgLarge: `work-capital-v1.png`,
        name: "Work10M",
        jobTitle: "VC",
        websiteLink: "https://theworkcapital.com/"
    }
];

interface AdvisorsInvestersProps {
    isMobile: boolean;
}

const AdvisorsInvesters = ({ isMobile }: AdvisorsInvestersProps) => {
    return (
        <section className={classnames(Styles.advisorsInvestorsSection, "flipAnimate")}>
            <div className="container">
                <div className={Styles.heading}>
                    <h2>
                        Meet our{" "}
                        <span data-hover="Advisors & Investors" className="indaiText">
                            Advisors & Investors
                        </span>
                    </h2>
                </div>

                <div className={Styles.ourTeamRow}>
                    {advisorsInvesters.map((advrInvest) => (
                        <div className={Styles.ourTeamCol} key={advrInvest.id}>
                            <OnScrollFadeIn>
                                <div className={Styles.ourTeamCard}>
                                    <A
                                        openInNewTab
                                        href={
                                            advrInvest.linkedinLink ? advrInvest.linkedinLink : advrInvest.websiteLink
                                        }
                                    >
                                        <div className={Styles.imageBox}>
                                            <AppImg
                                                src={advrInvest.profileImgLarge}
                                                alt={advrInvest.name}
                                                width={isMobile ? "175" : "265"}
                                                height={isMobile ? "200" : "300"}
                                                layout="responsive"
                                                quality={80}
                                            />
                                        </div>
                                        <div className={Styles.textBox}>
                                            <div className={Styles.nameTitle}>
                                                <h4>{advrInvest.name}</h4>
                                                <p>{advrInvest.jobTitle}</p>
                                            </div>
                                            <span className={Styles.linkedIn}>
                                                {advrInvest.linkedinLink ? (
                                                    <LinkedinIcon width="26" height="26" />
                                                ) : (
                                                    <ExternalLink width="26" height="26" />
                                                )}
                                            </span>
                                        </div>
                                    </A>
                                </div>
                            </OnScrollFadeIn>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AdvisorsInvesters;
